import styled from "styled-components";

const DisabledIconWrapper = styled.div`
    [class*="DropdownIcon"]::before {
        ${props => (props.disabled ? "color: #F2F3F4 !important;" : "")}
    }
`;

export default DisabledIconWrapper;
